import { render, staticRenderFns } from "./humanising.vue?vue&type=template&id=2707df23&scoped=true&lang=pug&"
import script from "./humanising.vue?vue&type=script&lang=js&"
export * from "./humanising.vue?vue&type=script&lang=js&"
import style0 from "./humanising.vue?vue&type=style&index=0&id=2707df23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2707df23",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/widgets/image.vue').default,WidgetsYoutubeVideo: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/widgets/youtube-video.vue').default})
